namespace RioERP.Users {
    export namespace PermissionKeys {
        export const General = "Users:General";

        namespace UsersManagement {
            export const Delete = "Users:UsersManagement:Delete";
            export const Modify = "Users:UsersManagement:Modify";
            export const View = "Users:UsersManagement:View";
        }
    }
}
